import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Layout from '../layouts/Layout';
import Header from '../modules/Header';
import Footer from '../modules/Footer';
import EmptySpace from '../modules/EmptySpace';
import EmailSignature from './EmailSignature';
import { url } from '../../../config';
import { PRIMARY_COLOR, GRAY_BG_COLOR } from '../../../constants';

//Style
import { body, bookingTitle, fontWeightBold, marginBottom, linkText } from '../../../helpers/getEmailStyles';

class BookingConfirmationHost extends React.Component {

  static propTypes = {
    content: PropTypes.shape({
      reservationId: PropTypes.number.isRequired,
      threadId: PropTypes.number.isRequired,
      guestName: PropTypes.string.isRequired,
      guestProfilePic: PropTypes.string.isRequired,
      guestJoinedDate: PropTypes.string.isRequired,
      checkIn: PropTypes.string.isRequired,
      checkOut: PropTypes.string.isRequired,
      guests: PropTypes.number.isRequired
    }).isRequired
  };

  render() {
    const { content: { reservationId, threadId, logo, siteName, listTitle } } = this.props;
    const { content: { guestName, guestProfilePic, guestJoinedDate, hostName } } = this.props;
    const { content: { checkIn, checkOut, guests } } = this.props;
    let checkInDate = checkIn != null ? moment(checkIn).format('ddd, Do MMM, YYYY') : '',
      checkOutDate = checkOut != null ? moment(checkOut).format('ddd, Do MMM, YYYY') : '';
    let itineraryURL;
    itineraryURL = url + '/users/trips/itinerary/' + reservationId;

    return (
      <Layout>
        <Header color={PRIMARY_COLOR} backgroundColor={GRAY_BG_COLOR} logo={logo} siteName={siteName} />
        <div style={body}>
          <h1 style={bookingTitle}>
            Bonjour {hostName}
          </h1>
          <EmptySpace height={20} />
          <div>
            Vous avez confirmé avec succès la réservation de {guestName}.
          </div>
          <EmptySpace height={20} />
          <div style={marginBottom}><span style={fontWeightBold}>Détails de la réservation :</span></div>
          <div style={marginBottom}><span style={fontWeightBold}>Nom de l'annonce :</span> {listTitle}</div>
          <div style={marginBottom}><span style={fontWeightBold}>Arrivée :</span> {checkInDate}</div>
          <div style={marginBottom}><span style={fontWeightBold}>Départ :</span> {checkOutDate}</div>
          <div style={marginBottom}><span style={fontWeightBold}>Voyageurs :</span>  {guests}</div>
          <div style={marginBottom}><span style={fontWeightBold}>ID de réservation :</span> {reservationId}</div>
          <div>
            <a href={itineraryURL} style={linkText}> Voir l'itinéraire</a>
          </div>
          <EmptySpace height={20} />
          <EmailSignature siteName={siteName} />
        </div>
        <EmptySpace height={40} />
        <Footer siteName={siteName} />
        <EmptySpace height={20} />
      </Layout>
    );
  }

}

export default BookingConfirmationHost;